import Scrollbar from './src/main';

export default Scrollbar;


// WEBPACK FOOTER //
// ./src/components/scrollbar/index.js